define('AwaLabs.RecipesAndEvents', [
    'RecipesAndEvents.View',
    'RecipesAndEvents.Facets.Browse.View',
    'RecipesAndEvents.Facets.ItemCell.View',
    'RecipesAndEvents.ProductDetails.Full.View',
    'RecipesAndEvents.ProductList.ControlItem.View',
    'RecipesAndEvents.Facets.Model',
    'RecipesAndEvents.Facets.ItemListSortSelector.View'
], function AwaLabsRecipesAndEvents() {});
